(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["cosmic-mall-h5-entry-app"] = factory();
	else
		root["cosmic-mall-h5-entry-app"] = factory();
})(self, function() {
return 